import apiClient from '../api';

export const getEditorAndProjectList = (editorId, header) => apiClient.get(`/editor-payment/${editorId}`, header);

export const updateEditorPayment = (id, data, header) => apiClient.put(`/editor-payment/update/${id}`, data, header);